module.exports = __webpack_public_path__ + "static/bg.fffbfd1b.jpg";